import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CurrentUserService } from './auth/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class HeaderHelperService {
  constructor(private currentUserService: CurrentUserService) {}

  getHeaders(): HttpHeaders {
    const currentUser = this.currentUserService.GetSession();
    const language = localStorage.getItem('app-lang') || 'en-US';
    const headers = new HttpHeaders({
      Authorization: `Bearer ${currentUser?.token}`,
      'X-Application-Code': 'SORE',
      'Content-Language': `${language}`,
    });
    return headers;
  }
}
